import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';

import { Text } from './text';

import { useTheme } from '@/components/theme-provider';

export interface TooltipProps {
	children: React.ReactNode;
	title: string;
	style?: ViewStyle;
	leaveTouchDelay?: number;
}

export const Tooltip: React.FC<TooltipProps> = ({ children, title, style, leaveTouchDelay }) => {
	const theme = useTheme();

	return (
		<View style={[styles.container, style]}>
			{children}
			<View style={[styles.tooltip, { backgroundColor: theme.colors.surfaceVariant }]}>
				<Text variant="bodySmall" style={{ color: theme.colors.onSurfaceVariant }}>
					{title}
				</Text>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		position: 'relative',
	},
	tooltip: {
		position: 'absolute',
		bottom: '100%',
		left: '50%',
		transform: [{ translateX: -50 }],
		padding: 8,
		borderRadius: 4,
		marginBottom: 4,
		zIndex: 1000,
	},
});
